import React, { useState } from "react";
import { Search, X, Filter } from "lucide-react";
import Navbar from "../components/navigation/Navbar";
import { useRegions } from "../context/RegionsContext";
import { settings } from "../library/allauth";
import { getCSRFToken } from "../library/django";
import MapComponent from "../components/map/mapComponent"; // ADD THIS

export default function ALPRSearch() {
  const [alprMarkers, setAlprMarkers] = useState([]);
  const { selectedRegion } = useRegions();
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedDetection, setSelectedDetection] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false); // ADD THIS LINE
  const [expandedPlates, setExpandedPlates] = useState({});
  const [fullscreenImage, setFullscreenImage] = useState(null);

  const handleSearch = async () => {
    if (!searchQuery.trim()) return;

    setIsLoading(true);
    try {
      const baseUrl = settings.baseUrl || "";
      const params = new URLSearchParams({
        plate_number: searchQuery,
      });

      // Add region filter if a specific region is selected
      if (selectedRegion && selectedRegion.region_id !== "all") {
        params.append("region_id", selectedRegion.region_id);
      }

      const response = await fetch(`${baseUrl}/alpr/search/?${params}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": getCSRFToken(),
        },
        credentials: settings.withCredentials ? "include" : "same-origin",
      });

      const data = await response.json();

      if (response.ok) {
        setSearchResults(data.results || []);
        setAlprMarkers(data.results || []); // ADD THIS - for map markers
        console.log("Found", data.count, "results");
      } else {
        console.error("Search error:", data.error);
        setSearchResults([]);
      }
    } catch (error) {
      console.error("Search error:", error);
      setSearchResults([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleResultClick = (result) => {
    setSelectedDetection(result);
  };

  return (
    <>
      <Navbar />

      <div className="h-screen bg-gray-50 pt-14 overflow-hidden">
        <div className="h-full flex flex-row-reverse">
          {/* Advanced Filters Panel - Right Side (20% width) */}
          {showAdvancedFilters && (
            <div className="w-[25%] bg-white border-l border-gray-200 flex flex-col p-4 overflow-y-auto space-y-4">
              {/* Header with Close Button */}
              <div className="flex justify-between items-center mb-2">
                <h3 className="font-semibold text-gray-900">
                  Advanced Filters
                </h3>
                <button
                  onClick={() => setShowAdvancedFilters(false)}
                  className="p-1 hover:bg-gray-200 rounded transition-colors"
                >
                  <X size={20} className="text-gray-600" />
                </button>
              </div>

              {/* Date/Time Range */}
              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-2">
                  Start Date & Time
                </label>
                <input
                  type="datetime-local"
                  className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                />
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-2">
                  End Date & Time
                </label>
                <input
                  type="datetime-local"
                  className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                />
              </div>

              {/* Location Search */}
              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-2">
                  Location Search
                </label>
                <select className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 outline-none bg-white">
                  <option>Distance from Point</option>
                  <option>Region of Interest (ROI)</option>
                </select>
              </div>

              {/* Vehicle Make */}
              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-2">
                  Make
                </label>
                <select className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 outline-none bg-white">
                  <option>Select Make</option>
                  <option>Toyota</option>
                  <option>Honda</option>
                  <option>Ford</option>
                  <option>BMW</option>
                </select>
              </div>

              {/* Vehicle Model */}
              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-2">
                  Model
                </label>
                <input
                  type="text"
                  placeholder="Enter model"
                  className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                />
              </div>

              {/* Vehicle Color */}
              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-2">
                  Color
                </label>
                <select className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 outline-none bg-white">
                  <option>Select Color</option>
                  <option>White</option>
                  <option>Black</option>
                  <option>Gray</option>
                  <option>Silver</option>
                  <option>Red</option>
                  <option>Blue</option>
                </select>
              </div>

              {/* AI Semantic Search */}
              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-2">
                  AI Search (Describe)
                </label>
                <textarea
                  placeholder="Describe the vehicle..."
                  rows="3"
                  className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 outline-none resize-none"
                ></textarea>
              </div>

              {/* Apply Button */}
              <button className="w-full px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors font-semibold text-sm mt-4">
                Apply Filters
              </button>
            </div>
          )}

          {/* Left Panel - Search & Results (20% width - stays same) */}
          {/* <div className="w-[20%] bg-white border-r border-gray-200 flex flex-col"> */}
          {/* <div className="w-[25%] bg-white border-r border-gray-200 flex flex-col"> */}
          <div className="w-[25%] bg-white border-r border-gray-200 flex flex-col transition-all duration-300">
            {/* Search Section */}
            <div className="p-4 border-b border-gray-200 space-y-3">
              <h2 className="text-lg font-semibold text-gray-800">
                ALPR Search
              </h2>

              {/* Active Region Display */}
              <div className="px-3 py-2 bg-blue-50 text-blue-700 text-sm rounded-md border border-blue-200">
                <span className="font-medium">Region:</span>{" "}
                {selectedRegion?.region_name || "All Regions"}
              </div>

              {/* Search Bar */}
              <div className="flex gap-2">
                <div className="flex-1 relative">
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) =>
                      setSearchQuery(e.target.value.toUpperCase())
                    }
                    onKeyPress={handleKeyPress}
                    placeholder="Insert License Plate Number"
                    className="w-full px-4 py-2 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 text-sm"
                  />
                  {/* Clear Button (X) */}
                  {searchQuery && (
                    <button
                      onClick={() => {
                        setSearchQuery("");
                        setSearchResults([]);
                        setAlprMarkers([]);
                      }}
                      className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-gray-200 rounded transition-colors"
                      title="Clear search"
                    >
                      <X size={16} className="text-gray-500" />
                    </button>
                  )}
                </div>
                <button
                  onClick={handleSearch}
                  disabled={isLoading || !searchQuery.trim()}
                  className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <Search size={20} />
                </button>
              </div>

              {/* Advanced Search Button - Below Search Bar */}
              <button
                onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
                className="w-full px-4 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold text-sm flex items-center justify-center gap-2"
              >
                <Filter size={18} />
                Advanced Search
              </button>
            </div>

            {/* Results List */}
            <div className="flex-1 overflow-y-auto p-2">
              {isLoading ? (
                <div className="flex items-center justify-center h-32">
                  <div className="flex flex-col items-center gap-2">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600"></div>
                    <p className="text-sm text-gray-500">Searching...</p>
                  </div>
                </div>
              ) : searchResults.length === 0 ? (
                <div className="flex items-center justify-center h-32">
                  <div className="text-center">
                    <p className="text-sm text-gray-500">
                      {searchQuery
                        ? "No results found"
                        : "Enter a license plate number to search"}
                    </p>
                  </div>
                </div>
              ) : (
                <div className="space-y-2">
                  {Object.entries(
                    searchResults.reduce((acc, result) => {
                      const plate = result.license_plate_number;
                      if (!acc[plate]) {
                        acc[plate] = [];
                      }
                      acc[plate].push(result);
                      return acc;
                    }, {}),
                  ).map(([plate, results]) => {
                    const toggleExpand = (plate) => {
                      setExpandedPlates((prev) => ({
                        ...prev,
                        [plate]: !prev[plate],
                      }));
                    };

                    const isExpanded = expandedPlates[plate] || false;

                    return (
                      <div
                        key={plate}
                        className="border border-gray-200 rounded-lg overflow-hidden"
                      >
                        {/* Group Header */}
                        <div
                          onClick={() => toggleExpand(plate)}
                          className="p-3 bg-emerald-50 hover:bg-emerald-100 cursor-pointer transition-colors flex items-center justify-between"
                        >
                          <div className="flex items-center gap-3 flex-1">
                            {/* Expand/Collapse Icon */}
                            <div
                              className={`transform transition-transform duration-300 ${isExpanded ? "rotate-90" : ""}`}
                            >
                              <svg
                                className="w-5 h-5 text-emerald-600"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>

                            {/* Plate Number */}
                            <div className="flex-1">
                              <p className="font-bold text-gray-900 text-sm">
                                {plate}
                              </p>
                              <p className="text-xs text-gray-600">
                                {results[0].vehicle_make}{" "}
                                {results[0].vehicle_model}
                              </p>
                            </div>
                          </div>

                          {/* Hit Count Badge */}
                          <span className="px-3 py-1 bg-emerald-600 text-white text-xs font-bold rounded-full">
                            {results.length}
                          </span>
                        </div>

                        {/* Expanded Results */}
                        {isExpanded && (
                          <div className="border-t border-gray-200 bg-white">
                            {results.map((result, idx) => (
                              <div
                                key={idx}
                                onClick={() => handleResultClick(result)}
                                className="p-3 border-b border-gray-100 last:border-b-0 hover:bg-blue-50 cursor-pointer transition-colors"
                              >
                                <div className="flex items-center gap-3">
                                  {/* Thumbnail */}
                                  <div className="w-12 h-12 bg-gray-100 rounded overflow-hidden flex-shrink-0">
                                    <img
                                      src={result.images?.thumbnail}
                                      alt="Vehicle"
                                      className="w-full h-full object-cover"
                                      onError={(e) => {
                                        e.target.style.display = "none";
                                        e.target.parentElement.innerHTML =
                                          '<div class="w-full h-full flex items-center justify-center"><span class="text-xs text-gray-400">IMG</span></div>';
                                      }}
                                    />
                                  </div>

                                  {/* Detection Info */}
                                  <div className="flex-1 min-w-0">
                                    <p className="text-xs font-semibold text-gray-900">
                                      {result.timestamp}
                                    </p>
                                    <p className="text-xs text-gray-500">
                                      Site {result.site_id} •{" "}
                                      {result.vehicle_color}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>

          {/* Map Panel - Dynamic width */}
          <div className="w-[75%] relative bg-gray-100">
            <MapComponent
              useGlobalRegion={true}
              alprMarkers={alprMarkers}
              onMarkerClick={handleResultClick}
              hideDefaultMarkers={searchResults.length > 0}
            />
          </div>

          {/* Detail Popup Modal - KEPT INTACT */}
          {selectedDetection && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] p-4">
              <div className="bg-white rounded-lg shadow-2xl w-full max-w-3xl relative">
                {/* Header */}
                <div className="flex justify-between items-center px-6 py-3 border-b border-gray-200 bg-gray-50">
                  <h2 className="text-base font-semibold text-gray-900">
                    Detection Details
                  </h2>
                  <button
                    onClick={() => setSelectedDetection(null)}
                    className="p-1.5 hover:bg-gray-200 rounded-lg transition-colors"
                  >
                    <X size={18} className="text-gray-600" />
                  </button>
                </div>

                {/* Content - Two Columns */}
                <div className="p-6">
                  <div className="grid grid-cols-2 gap-6">
                    {/* Left Column - Images */}
                    <div className="space-y-3">
                      {/* Vehicle Image */}
                      <div className="relative group">
                        <div className="h-44 bg-gray-100 rounded-lg overflow-hidden">
                          <img
                            src={selectedDetection.images?.vehicle}
                            alt="Vehicle"
                            className="w-full h-full object-cover"
                            onError={(e) => {
                              e.target.style.display = "none";
                              e.target.parentElement.innerHTML =
                                '<div class="w-full h-full flex items-center justify-center"><span class="text-gray-400 text-sm">Vehicle Image</span></div>';
                            }}
                          />
                        </div>
                        <button
                          onClick={() =>
                            setFullscreenImage(
                              selectedDetection.images?.vehicle,
                            )
                          }
                          className="absolute top-2 right-2 p-2 bg-black bg-opacity-60 hover:bg-opacity-80 rounded-lg transition-all opacity-0 group-hover:opacity-100"
                          title="Expand to fullscreen"
                        >
                          <svg
                            className="w-5 h-5 text-white"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M10 6H6v12h12v-4m7-11V3m0 0h-7m7 0l-10 10"
                            />
                          </svg>
                        </button>
                      </div>

                      {/* Plate Closeup - Same width as vehicle, larger height */}
                      <div className="relative group">
                        <div className="h-36 bg-gray-900 rounded-lg overflow-hidden flex items-center justify-center">
                          <img
                            src={selectedDetection.images?.plate}
                            alt="Plate"
                            className="w-full h-full object-contain"
                            onError={(e) => {
                              e.target.style.display = "none";
                              e.target.parentElement.innerHTML =
                                '<div class="w-full h-full flex items-center justify-center"><span class="text-gray-400 text-xs">Plate Closeup</span></div>';
                            }}
                          />
                        </div>
                        <button
                          onClick={() =>
                            setFullscreenImage(
                              selectedDetection.images?.plate,
                            )
                          }
                          className="absolute top-2 right-2 p-2 bg-black bg-opacity-60 hover:bg-opacity-80 rounded-lg transition-all opacity-0 group-hover:opacity-100"
                          title="Expand to fullscreen"
                        >
                          <svg
                            className="w-5 h-5 text-white"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M10 6H6v12h12v-4m7-11V3m0 0h-7m7 0l-10 10"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>

                    {/* Right Column - Details */}
                    <div className="space-y-4">
                      {/* Vehicle Info - 2 columns */}
                      <div className="grid grid-cols-2 gap-x-4 gap-y-3">
                        <div>
                          <p className="text-xs text-gray-500 mb-0.5">
                            License Plate
                          </p>
                          <p className="text-sm font-semibold text-gray-900">
                            {selectedDetection.license_plate_number}
                          </p>
                        </div>
                        <div>
                          <p className="text-xs text-gray-500 mb-0.5">State</p>
                          <p className="text-sm font-semibold text-gray-900">
                            {selectedDetection.license_plate_state}
                          </p>
                        </div>
                        <div>
                          <p className="text-xs text-gray-500 mb-0.5">Make</p>
                          <p className="text-sm font-semibold text-gray-900">
                            {selectedDetection.vehicle_make}
                          </p>
                        </div>
                        <div>
                          <p className="text-xs text-gray-500 mb-0.5">Model</p>
                          <p className="text-sm font-semibold text-gray-900">
                            {selectedDetection.vehicle_model}
                          </p>
                        </div>
                        <div>
                          <p className="text-xs text-gray-500 mb-0.5">Color</p>
                          <p className="text-sm font-semibold text-gray-900">
                            {selectedDetection.vehicle_color}
                          </p>
                        </div>
                        <div>
                          <p className="text-xs text-gray-500 mb-0.5">Class</p>
                          <p className="text-sm font-semibold text-gray-900">
                            {selectedDetection.vehicle_class}
                          </p>
                        </div>
                        <div>
                          <p className="text-xs text-gray-500 mb-0.5">Time</p>
                          <p className="text-sm font-semibold text-gray-900">
                            {selectedDetection.timestamp}
                          </p>
                        </div>
                        <div>
                          <p className="text-xs text-gray-500 mb-0.5">
                            Location
                          </p>
                          <p className="text-sm font-semibold text-gray-900">
                            System {selectedDetection.system_id}
                          </p>
                        </div>
                      </div>

                      {/* Physical Features */}
                      {selectedDetection.descriptors &&
                        selectedDetection.descriptors.physical_features &&
                        selectedDetection.descriptors.physical_features.length >
                          0 && (
                          <div className="pt-3 border-t border-gray-200">
                            <p className="text-xs text-gray-500 mb-2">
                              Physical Features
                            </p>
                            <div className="flex flex-wrap gap-1.5">
                              {selectedDetection.descriptors.physical_features.map(
                                (feature, idx) => (
                                  <span
                                    key={idx}
                                    className="px-2 py-0.5 bg-emerald-50 text-emerald-700 text-xs rounded border border-emerald-200"
                                  >
                                    {feature.replace(/_/g, " ")}
                                  </span>
                                ),
                              )}
                            </div>
                            {selectedDetection.descriptors
                              .distinguishing_marks && (
                              <p className="text-xs text-gray-600 mt-2 italic">
                                {
                                  selectedDetection.descriptors
                                    .distinguishing_marks
                                }
                              </p>
                            )}
                          </div>
                        )}

                      {/* Confidence Scores with Thresholds */}
                      <div className="pt-3 border-t border-gray-200">
                        <p className="text-xs text-gray-500 mb-2">
                          Detection Confidence
                        </p>
                        <div className="grid grid-cols-3 gap-2">
                          {/* Plate Confidence */}
                          <div className="text-center p-2 bg-gray-50 rounded">
                            <p className="text-xs text-gray-600 mb-2 font-semibold">
                              Plate
                            </p>
                            {selectedDetection.confidence_license_plate_number ? (
                              <div
                                className={`px-2 py-1 rounded text-xs font-bold text-white ${
                                  selectedDetection.confidence_license_plate_number >=
                                  0.85
                                    ? "bg-green-600"
                                    : selectedDetection.confidence_license_plate_number >=
                                        0.65
                                      ? "bg-yellow-600"
                                      : "bg-red-600"
                                }`}
                              >
                                {selectedDetection.confidence_license_plate_number >=
                                0.85
                                  ? "High"
                                  : selectedDetection.confidence_license_plate_number >=
                                      0.65
                                    ? "Medium"
                                    : "Low"}
                              </div>
                            ) : (
                              <p className="text-xs text-gray-500">N/A</p>
                            )}
                          </div>

                          {/* Vehicle Confidence */}
                          <div className="text-center p-2 bg-gray-50 rounded">
                            <p className="text-xs text-gray-600 mb-2 font-semibold">
                              Vehicle
                            </p>
                            {selectedDetection.confidence_vehicle_avg ? (
                              <div
                                className={`px-2 py-1 rounded text-xs font-bold text-white ${
                                  selectedDetection.confidence_vehicle_avg >=
                                  0.85
                                    ? "bg-green-600"
                                    : selectedDetection.confidence_vehicle_avg >=
                                        0.65
                                      ? "bg-yellow-600"
                                      : "bg-red-600"
                                }`}
                              >
                                {selectedDetection.confidence_vehicle_avg >=
                                0.85
                                  ? "High"
                                  : selectedDetection.confidence_vehicle_avg >=
                                      0.65
                                    ? "Medium"
                                    : "Low"}
                              </div>
                            ) : (
                              <p className="text-xs text-gray-500">N/A</p>
                            )}
                          </div>

                          {/* State Confidence */}
                          <div className="text-center p-2 bg-gray-50 rounded">
                            <p className="text-xs text-gray-600 mb-2 font-semibold">
                              State
                            </p>
                            {selectedDetection.confidence_license_plate_state ? (
                              <div
                                className={`px-2 py-1 rounded text-xs font-bold text-white ${
                                  selectedDetection.confidence_license_plate_state >=
                                  0.85
                                    ? "bg-green-600"
                                    : selectedDetection.confidence_license_plate_state >=
                                        0.65
                                      ? "bg-yellow-600"
                                      : "bg-red-600"
                                }`}
                              >
                                {selectedDetection.confidence_license_plate_state >=
                                0.85
                                  ? "High"
                                  : selectedDetection.confidence_license_plate_state >=
                                      0.65
                                    ? "Medium"
                                    : "Low"}
                              </div>
                            ) : (
                              <p className="text-xs text-gray-500">N/A</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Close Button */}
                  <div className="flex justify-end pt-4 mt-4 border-t border-gray-200">
                    <button
                      onClick={() => setSelectedDetection(null)}
                      className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm font-medium"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Fullscreen Image Modal */}
      {fullscreenImage && (
        <div className="fixed inset-0 bg-black bg-opacity-95 flex items-center justify-center z-[10000] p-4">
          <div className="relative w-full h-full flex items-center justify-center">
            <img
              src={fullscreenImage}
              alt="Fullscreen"
              className="max-w-full max-h-full object-contain"
            />
            <button
              onClick={() => setFullscreenImage(null)}
              className="absolute top-4 right-4 p-2 bg-white hover:bg-gray-200 rounded-lg transition-colors"
            >
              <X size={24} className="text-black" />
            </button>
          </div>
        </div>
      )}
    </>
  );
}
